import { render, staticRenderFns } from "./GiveawayExcelTable.vue?vue&type=template&id=64ff26c0&scoped=true"
import script from "./GiveawayExcelTable.vue?vue&type=script&lang=ts"
export * from "./GiveawayExcelTable.vue?vue&type=script&lang=ts"
import style0 from "./GiveawayExcelTable.vue?vue&type=style&index=0&id=64ff26c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff26c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ff26c0')) {
      api.createRecord('64ff26c0', component.options)
    } else {
      api.reload('64ff26c0', component.options)
    }
    module.hot.accept("./GiveawayExcelTable.vue?vue&type=template&id=64ff26c0&scoped=true", function () {
      api.rerender('64ff26c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/components/GiveawayExcelTable.vue"
export default component.exports